<template>
  <span v-html="data_home_page.home_text"></span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['data_home_page'])
  }
}
</script>
